import React, { useState } from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import PageWrapper from './style';
import PageTitle from '../../components/common/PageTitle';
import { connect } from 'react-redux';
import AdvertisementTable from '../../components/advertisement/AdvertisementTable';
import EventAdvertisementManager from '../../components/advertisement/EventAdvertisementManager';
import AdvertisementAnalytics from '../../components/advertisement/AdvertisementAnalytics';

const Advertisement = (props) => {
	const [activeTab, setActiveTab] = useState('1');

	const toggleTab = (tab) => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	return (
		<PageWrapper {...props}>
			<PageTitle title="sidebar.advertisement" className="plr-15" />
			
			<div className="plr-15">
				<Nav tabs className="mb-4">
					<NavItem>
						<NavLink
							className={activeTab === '1' ? 'active' : ''}
							onClick={() => toggleTab('1')}
							style={{ cursor: 'pointer' }}
						>
							<i className="fas fa-list mr-2"></i>
							Advertisement List
						</NavLink>
					</NavItem>
					<NavItem>
						<NavLink
							className={activeTab === '2' ? 'active' : ''}
							onClick={() => toggleTab('2')}
							style={{ cursor: 'pointer' }}
						>
							<i className="fas fa-sort mr-2"></i>
							Event Display Order
						</NavLink>
					</NavItem>
					<NavItem>
						<NavLink
							className={activeTab === '3' ? 'active' : ''}
							onClick={() => toggleTab('3')}
							style={{ cursor: 'pointer' }}
						>
							<i className="fas fa-chart-bar mr-2"></i>
							Analytics
						</NavLink>
					</NavItem>
				</Nav>
				
				<TabContent activeTab={activeTab}>
					<TabPane tabId="1">
						<div className="user-tbl">
							<AdvertisementTable {...props} />
						</div>
					</TabPane>
					<TabPane tabId="2">
						<EventAdvertisementManager {...props} />
					</TabPane>
					<TabPane tabId="3">
						<AdvertisementAnalytics {...props} />
					</TabPane>
				</TabContent>
			</div>
		</PageWrapper>
	);
};

const mapStateToProps = (state) => {
	return {
		...state.themeChanger,
	};
};

export default connect(mapStateToProps, null)(Advertisement);
